<!-- 法律律所认证页面 -->
<template>
    <div class="content">
        <!-- 百家号封禁状态 -->
        <div v-if="status === 'freeze'" class="in-freeze">
            <div class="blank"></div>
            <div class="text">您的百家号账号当前处于封禁状态，暂无法进行律所资质认证，您可前往
                <a href="https://baijiahao.baidu.com/builder/rc/stores/outComplain?aside=0&freezeModal=0&fixedBottom=0" target="_blank">百家号</a>
                进行申诉
            </div>
        </div>
        <!-- 企业和其他机构的审核中及审核失败状态 -->
        <div v-else-if="subType === 'company' || subType === 'other'">
            <!-- 百家号认证审核中 -->
            <div v-if="status === 'audit'" class="in-check">
                <div class="blank"></div>
                <div class="text">当前您的企业百家号信息正在审核中，审核结果将于1-3日内短信告知您，请审核通过后再登陆</div>
                <a
                    href="https://baijiahao.baidu.com/builder/rc/settings/accountSet?"
                    target="_blank"
                    style="color: #3855d5"
                >点击查看企业百家号认证信息</a>
            </div>
            <!-- 百家号审核失败 -->
            <div v-if="status === 'unpass'" class="in-check">
                <div class="blank"></div>
                <div class="text">您的企业百家号认证信息审核失败，请返回百家号重新提交认证信息</div>
                <a
                    href="https://baijiahao.baidu.com/builder/rc/settings/accountSet?"
                    target="_blank"
                    style="color: #3855d5"
                >点击查看企业百家号认证信息</a>
            </div>
        </div>
        <!-- 个人百家号的审核中及审核失败状态 -->
        <div v-else-if="subType === 'individual' && (status === 'audit' || status === 'unpass')">
            <!-- 百家号认证审核中 -->
            <div v-if="status === 'audit'" class="in-check">
                <div class="blank"></div>
                <div class="text">当前您的百家号信息正在审核中，审核结果将于1-3日内短信告知您，请审核通过后再登陆</div>
                <a
                    href="https://baijiahao.baidu.com/builder/rc/settings/accountSet?"
                    target="_blank"
                    style="color: #3855d5"
                >点击查看百家号认证信息</a>
            </div>
            <!-- 百家号审核失败 -->
            <div v-if="status === 'unpass'" class="in-check">
                <div class="blank"></div>
                <div class="text">您的百家号认证信息审核失败，请返回百家号重新提交认证信息</div>
                <a
                    href="https://baijiahao.baidu.com/builder/rc/settings/accountSet?"
                    target="_blank"
                    style="color: #3855d5"
                >点击查看百家号认证信息</a>
            </div>
        </div>
        <!-- 新账户或者是个人百家号其他状态全部跳到引导企百入驻页 -->
        <template v-else>
            <div class="header">
                <div class="back-title-box">
                    <div class="back" @click="showBackModal">返回</div>
                    <div class="line"></div>
                    <div>更改入驻类型</div>
                </div>
                <div class="center-title">
                    <div class="title">您需要先注册企业百家号才可进行律所入驻</div>
                    <div class="title-tip">
                        <a
                            href="https://baijiahao.baidu.com/builder/theme/bjh/login" target="_blank"
                            style="color: #0055ff"
                        >去注册企业百家号</a>
                        <veui-icon class="icon-tip" name="chevron-right"></veui-icon>
                    </div>
                </div>
                <div class="tip">
                    <img class="tip-img" src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/account/enter-tip.png">
                    <div>依据以下3步注册企业百家号</div>
                </div>
                <div ref="carousel" class="carousel">
                    <div class="click-area"><a href="https://baijiahao.baidu.com/builder/theme/bjh/login" target="_blank"></a></div>
                    <img
                        class="first"
                        src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/account/first-step.png"
                        alt=""
                    >
                    <img
                        class="second"
                        src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/account/second-step.png"
                        alt=""
                    >
                    <img
                        class="third"
                        src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/account/third-step.png"
                        alt=""
                    >
                </div>
                <!-- 轮播图底部进度条 -->
                <div class="pagination">
                    <div
                        class="step"
                        :class="{'active': step === 1}"
                        @click="step = 1"
                    ></div>
                    <div
                        class="step"
                        :class="{'active': step === 2}"
                        @click="step = 2"
                    ></div>
                </div>
                <!-- 轮播图左右两侧阴影 -->
                <div v-if="step === 2" class="left-shadow"></div>
                <div v-if="step === 1" class="right-shadow"></div>
                <!-- 轮播图左右两侧箭头 -->
                <div
                    v-if="step === 2"
                    class="arrow left-arrow"
                    @click="step = 1"
                ><veui-icon class="icon" name="chevron-left"></veui-icon></div>
                <div
                    v-if="step === 1"
                    class="arrow right-arrow"
                    @click="step = 2"
                ><veui-icon class="icon" name="chevron-right"></veui-icon></div>
            </div>
            <!-- 线上 -->
            <!-- <iframe
                id="bjh-iframe"
                class="bjh-authentication"
                frameborder="0"
                src="https://baijiahao.baidu.com/builder/theme/bjh/confirmInfo?appKey=lvlin"
            ></iframe> -->
            <!-- 测试环境 -->
            <!-- <iframe
                class="bjh-authentication"
                id="bjh-iframe"
                frameborder="0"
                src="http://yq01-ps-beehive-agent245887.yq01.baidu.com:8509/builder/theme/bjh/confirmInfo?appKey=lvlin"
            ></iframe> -->
        </template>
        <veui-dialog
            overlay-class="back-confirm"
            title="确定要更改您的入驻类型吗？"
            :loading="isBacking"
            :open.sync="isBackModalShow"
        >
            <div>
                <p class="confirm-text">点击确认后，您当前填写的所有信息将不会被记录，请谨慎选择</p>
            </div>
            <template #foot>
                <div class="btn-box">
                    <a class="btn-item" @click="cancelBack">我再想想</a>
                    <a class="btn-item confirm" @click="confirmBack">确认</a>
                </div>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @file 法律律所认证页面
 * @description 法律律所认证页面
 * @author dingzhenyue@baidu.com
 */
import $http from '@/utils/ajax.js';
import {Dialog, Icon} from 'veui';

export default {
    components: {
        'veui-dialog': Dialog,
        'veui-icon': Icon
    },
    data() {
        return {
            // 返回弹窗展示
            isBackModalShow: false,
            // 返回确认提交中
            isBacking: false,
            step: 1 // 轮播图步骤
        };
    },
    props: {
        // 百家号的审核状态
        status: {
            'type': String,
            'default': ''
        },
        // 百家号类型 individual: 个人 company/other: 企业或其他机构
        subType: {
            'type': String,
            'default': ''
        },
        uk: {
            'type': String,
            'default': ''
        }
    },
    methods: {
        axiosRequest(options = {}) {
            return new Promise((resolve, reject) => {
                if (!options.url) {
                    return;
                }
                $http(options).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject({
                        msg: err.data && err.data.msg || '网络错误'
                    });
                });
            });
        },
        // 展示返回弹窗
        showBackModal() {
            this.isBackModalShow = true;
        },
        // 取消返回更改入驻类型
        cancelBack() {
            this.isBackModalShow = false;
        },
        // 确认返回更改入驻类型
        confirmBack() {
            if (this.isBacking) {
                return;
            }
            this.isBacking = true;
            this.axiosRequest({
                url: '/bp/api/business/delbusiness',
                method: 'POST',
                withCredentials: true,
                params: {}
            }).then(res => {
                if (+res.code === 0) {
                    // 成功清除入驻信息，刷新页面回到选择入驻位置
                    this.isBackModalShow = false;
                    let clickFirmBtnInfo = JSON.parse(localStorage.getItem('clickFirmBtn'));
                    if (clickFirmBtnInfo && clickFirmBtnInfo[this.uk]) {
                        clickFirmBtnInfo[this.uk] = 0;
                        localStorage.setItem('clickFirmBtn', JSON.stringify({
                            ...clickFirmBtnInfo
                        }));
                        window.location.reload();
                    }
                    return;
                }
                this.$Message.error(res.msg);
            }).catch(err => {
                this.$Message.error('网络错误，请稍后重试！');
            }).finally(() => {
                this.isBacking = false;
            });
        }
    },
    watch: {
        step(val) {
            if (val === 2) {
                if (this.$refs.carousel) {
                    this.$refs.carousel.style.transform = 'translateX(-670px)';
                }
            }
            else {
                if (this.$refs.carousel) {
                    this.$refs.carousel.style.transform = 'translateX(0px)';
                }
            }
        }
    }
};
</script>

<style lang='less' scoped>
.content {
    height: 100%;
    width: 100%;
    padding: 54px 20px 57px;

    .bjh-authentication {
        width: 100%;
        margin-top: 10px;
        border-radius: 10px;
    }

    .header {
        height: 100%;
        width: 100%;
        position: relative;
        overflow: hidden;
        text-align: left;

        .center-title {
            text-align: center;
            margin-top: -40px;
        }

        .left-shadow {
            position: absolute;
            left: 0;
            top: 115px;
            height: 470px;
            width: 110px;
            background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
        }

        .right-shadow {
            position: absolute;
            right: 0;
            top: 115px;
            height: 470px;
            width: 110px;
            background: linear-gradient(to left, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
        }

        .arrow {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 34px;
            height: 96px;
            border-radius: 10px;
            background-color: rgba(0, 85, 255, .1);
            cursor: pointer;

            &:hover {
                background-color: rgba(0, 85, 255, .35);

                .icon {
                    color: #5a7cc7;
                }
            }

            .icon {
                color: #799be1;
                width: 18px;
                height: 30px;
            }
        }

        .left-arrow {
            position: absolute;
            left: 42px;
            top: 300px;
        }

        .right-arrow {
            position: absolute;
            right: 42px;
            top: 300px;
        }

        .pagination {
            display: flex;
            justify-content: center;
            width: 100%;
            position: absolute;
            bottom: 0;

            .step {
                width: 32px;
                height: 4px;
                border-radius: 2px;
                margin-right: 10px;
                background-color: rgba(0,85,255,.2);
                cursor: pointer;
            }

            .active {
                background-color: rgb(0,85,255);
            }
        }

        .back-title-box {
            display: flex;
            align-items: center;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            line-height: 16px;
            color: #333;
            margin-bottom: 24px;

            .back {
                position: relative;
                padding-left: 12px;
                cursor: pointer;

                &::before {
                    content: "";
                    position: absolute;
                    height: 12px;
                    width: 10px;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    background: url(https://lvlin-base.cdn.bcebos.com/bend/back-icon.png) no-repeat center center / 100% 100%;
                }
            }

            .line {
                width: 1px;
                height: 10px;
                background: #9d9d9d;
                margin: 0 12px;
            }
        }

        .title {
            font-family: PingFangSC-Medium;
            font-size: 30px;
            color: #1e1f24;
            line-height: 30px;
            font-weight: 500;
            margin-bottom: 12px;
            &-tip {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 12px;
                .icon-tip {
                    margin-left: 5px;
                    color: #0055ff;
                    height: 15px;
                }
            }
        }

        .sub-title {
            margin-top: 16px;
        }

        .tip {
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: PingFangSC-Regular;
            width: 231px;
            height: 43px;
            background-color: #f5f6f9;
            border-radius: 8px;
            margin-top: 2px;

            .tip-img {
                width: 16px;
                height: 16px;
                margin-right: 10px;
            }
        }

        .carousel {
            position: relative;
            display: flex;
            flex-wrap: nowrap;
            transition: all .5s;
            margin-bottom: 20px;

            .click-area {
                position: absolute;
                z-index: 2;
                left: 50px;
                bottom: 22px;
                width: 170px;
                height: 22px;
                cursor: pointer;

                a {
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                }
            }

            .first {
                width: 287px;
                height: 463px;
                margin-left: -10px;
            }

            .second {
                width: 513px;
                height: 463px;
            }

            .third {
                width: 977px;
                height: 463px;
            }
        }
    }

    .in-check,
    .in-freeze {
        padding-top: 167px;
        height: 540px;

        .blank {
            height: 180px;
            width: 200px;
            background: url("https://lvlin-base.cdn.bcebos.com/bend/no-data.png") no-repeat center center;
            background-size: cover;
            margin: 0 auto;
        }

        .text {
            margin-top: 12px;
            color: #333335;
            text-align: center;
            line-height: 14px;
            margin-bottom: 16px;
        }
    }
}

.back-confirm {
    ::v-deep{
        .veui-dialog-content {
            width: 400px;
        }
    }
    .confirm-text {
        line-height: 24px;
        color: #000;
    }

    .btn-box {
        display: flex;
        align-items: center;
        justify-content: center;

        .btn-item {
            width: 116px;
            text-align: center;
            border: 1px solid #3e4cff;
            border-radius: 5px;
            padding: 10px 29px;
            font-size: 14px;
            color: #3e4cff;
            cursor: pointer;

            &.confirm {
                background: #3e4cff;
                color: #fff;
                margin-left: 24px;

                &:hover {
                    background: #2739d6;
                }
            }
        }
    }
}
</style>
